import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import InputBox from '../InputBox/InputBox';
import { isPasswordValid } from '@solarwindscloud/swicus-validation';
import { passwordRestrictionsMessage } from '../../utils/utils';
import styles from './PasswordInput.module.scss';

export const testIds = {
  passwordInput: 'password-input',
};

const PasswordInput = React.forwardRef(({ onError, onBlur, value, hasError, errorMessage, ...rest }, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const errorText = errorMessage || passwordRestrictionsMessage;

  const validatePassword = useCallback(() => {
    const inputValue = value || ref?.current?.inputRef?.current?.value;
    if (onError && !isPasswordValid(inputValue)) {
      onError(errorText);
    }
    if (onBlur) onBlur();
  }, [value, ref, onError, onBlur, errorText]);

  const handleShowPasswordClick = useCallback(() => {
    setShowPassword(!showPassword);
  }, [showPassword]);

  return (
    <InputBox
      label="Password"
      name="password"
      icon="locked"
      placeholder="Password"
      type={showPassword ? 'text' : 'password'}
      onBlur={validatePassword}
      errorMessage={hasError ? errorText : null}
      rightIconName="eye"
      rightIconClassname={showPassword ? styles.iconClicked : ''}
      onClickRightIcon={handleShowPasswordClick}
      data-test-password-input
      value={value}
      ref={ref}
      dataTestString={testIds.passwordInput}
      {...rest}
    />
  );
});

PasswordInput.propTypes = {
  value: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  hasError: PropTypes.bool,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.string,
  errorMessage: PropTypes.string,
};

export default PasswordInput;
